import './App.css';
import Header from './components/Header';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Home from './pages/Home';
import Cart from './pages/Cart';
import PageNotFound from './pages/PageNotFound';

function App() {
  return (
    <div className="App">
     
      <BrowserRouter>
       <Header/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/cart' element={<Cart/>}/>
          <Route path = '*' element={<PageNotFound/>}/>
        </Routes>
      </BrowserRouter>
      Cart
    </div>
  );
}

export default App;
